import { UserDisplayType } from '@mkp/user/models';
import { ProductPlatformGroup } from '@mkp/shared/models';
import { TrafficFunnel, trafficFunnelPlatform } from '@mkp/shared/models';

export const getLogoPlatformClass = (
  funnel: TrafficFunnel | undefined,
  displayType: UserDisplayType | undefined
): ProductPlatformGroup[] => {
  const platform: ProductPlatformGroup | undefined = funnel
    ? getPlatformClassByTraficFunnel(funnel as TrafficFunnel)
    : getPlatformClassByDisplayType(displayType);

  return platform ? [platform] : Object.values(ProductPlatformGroup);
};

export const getPlatformClassByDisplayType = (
  displayType: UserDisplayType | undefined
): ProductPlatformGroup | undefined =>
  displayType ? userDisplayTypePlatform[displayType] : undefined;

export const getPlatformClassByTraficFunnel = (
  funnel: TrafficFunnel | undefined
): ProductPlatformGroup | undefined => (funnel ? trafficFunnelPlatform[funnel] : undefined);

export const getButtonPlatformClass = (
  platform: ProductPlatformGroup | string | undefined
): string[] => [platform ? `button-color-${platform}` : ''];

export const userDisplayTypePlatform: {
  [userDisplayType in UserDisplayType]?: ProductPlatformGroup;
} = {
  [UserDisplayType.CustomerJobScout24]: ProductPlatformGroup.JobScout24,
  [UserDisplayType.CustomerJobs]: ProductPlatformGroup.Jobs,
  [UserDisplayType.CustomerJobUp]: ProductPlatformGroup.JobUp,
};
